import factory from "./factory";
const EndPoint = factory("Client", "clients");

const routes = [
  EndPoint("Tasks", "tasks"),
  EndPoint("Notes", "notes"),
  EndPoint("Surveys", "surveys"),
  EndPoint("Rewards", "rewards"),
  EndPoint("Commitments", "commitments"),
  EndPoint("Courses", "courses"),
  EndPoint("Modules", "modules"),
  EndPoint("HabitPrograms", "habit-programs"),
  EndPoint("CourseExercises", "course-exercises"),
  EndPoint("AreasOfGrowth", "areas-of-growth"),
  EndPoint("Raffle", "raffles"),
  EndPoint("Invitation", "invitations"),
  EndPoint("Goals", "goals"),
  EndPoint("AreaOfGrowth", "client-areas-of-growth"),
  EndPoint("ExercisesHistory", "exercise-history"),
  EndPoint("SurveyQuestionAnswer", "survey-question-answers"),
  EndPoint("MessagingRooms", "messaging-rooms"),
  EndPoint("Messages", "messages"),
  EndPoint("KPI", "kpis"),
  EndPoint("KPIResult", "kpi-results"),
  EndPoint("Habits", "habits"),
  EndPoint("HabitInstances", "habit-instances"),
  EndPoint("Assessments", "assessments"),
  EndPoint("Milestones", "milestones"),
  EndPoint("Subscription", "subscriptions")
];

export default routes;
